export const sortByList = [
    {
        label: "Alphabetic",
        value: "alpha",
    },
    {
        label: "Newly published",
        value: "new_published",
    },
    {
        label: "Played Ranking",
        value: "played_ranking",
    },
    {
        label: "Played Count",
        value: "played_count",
    },
];